import styled from "styled-components";
import { devices } from '../../../../src/globalStyle'

export const Content = styled.div`
  width: 100%;
  margin-top: 1rem;
  overflow-y: auto;
  overflow-x: auto;
  font-family: 'Inter', sans-serif;
  max-height: 70vh;
  display: block;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  padding-bottom: 3rem;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

export const FilterDiv = styled.div`
  display: flex;
  width: 7vw;
  border: 1.6px solid #0090d3;
  background-color: #fff;
  border-radius: 1.5vw;
  align-items: center;
  cursor: pointer;

  @media ${devices.largeDesktop} {
    width: 5vw;
    height: 4vh;
  }
`

export const FilterImg = styled.img`
  margin-left: 0.7vw;
  height: 4vh;
  @media ${devices.largeDesktop} {
    margin-left: 0.4vw;
    height: 3vh;
  }
`

export const FilterText = styled.h2`
  margin-left: 0.3vw;
  font-size: 0.95vw;
  color: #0090d3;

  @media ${devices.largeDesktop} {
    margin-left: 0.2vw;
    font-size: 0.75vw;
  }
`

export const ButtonCreate = styled.div`
  font-weight: bold;
  user-select: none;
  display: flex;
  height: 5.8vh;
  align-items: center;
  font-size: .8rem;
  padding: 0 1.5rem;
  color: #fff;
  cursor: pointer;
  background-color: #0090D3;
  border-radius: 2rem;
  img{
    height: .8rem;
    margin-right: 0.4rem;
  }
`

export const BlurBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    backdrop-filter: blur(3px);
    background-color: rgba(0, 0, 0, 0.4); 
    z-index: 1000;
    display: flex; 
    justify-content: center; 
    align-items: center;
`;
